import React, { FunctionComponent } from 'react';
import { Presentation } from './presentation';
import { PersonShowDetailsProps as Props } from './types';

export const Component: FunctionComponent<Props> = ({
  personId,
  isPc,
  isOneYearPassed,
  selected_statuses,
  memo,
  applies,
  events,
  isMemoModalOpen,
  handleMemoChange,
  handleSelectionStatusChanged,
  fetchValue,
  handleCloseMemoModal,
}) => {
  return (
    <Presentation
      state={{
        memo,
        applies,
        events,
        isMemoModalOpen,
      }}
      isPc={isPc}
      isOneYearPassed={isOneYearPassed}
      selected_statuses={selected_statuses}
      handleMemoChange={handleMemoChange}
      handleSelectionStatusChanged={handleSelectionStatusChanged}
      fetchValue={fetchValue}
      handleCloseMemoModal={handleCloseMemoModal}
    />
  );
};
